import { db } from "../firebaseConfig";
import {
  doc,
  setDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  getDocs,
  collection,
} from "firebase/firestore";

const NAME_SPACE = "posts";

const createPost = (data) => {
  return setDoc(doc(db, NAME_SPACE, data.slug), data);
};

const updatePost = (data) => {
  return setDoc(doc(db, NAME_SPACE, data.slug), data, { merge: true });
};

const deletePost = (slug) => {
  return deleteDoc(doc(db, NAME_SPACE, slug));
};

const getPosts = ({ type }) => {
  const postsRef = collection(db, NAME_SPACE);
  const q = query(postsRef, where("type", "==", type), orderBy("order"));
  return getDocs(q).then((querySnapshot) => {
    let data = [];
    querySnapshot.forEach((document) => {
      data.push(document.data());
    });
    return data;
  });
};

export default { getPosts, createPost, updatePost, deletePost };
